import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { warehousePageActions } from '@/Pages/Warehouse/services';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';

export function useWarehouse() {
  const dispatch: AppDispatch = useDispatch();

  const {
    tours: {
      Warehouse: { PageTour, CreateUnitTour, UpdateUnitTour },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: PageTour.Title,
      steps: [
        {
          content: PageTour.Step1.Text,
          placement: 'auto',
          target: '#warehousePage',
          title: PageTour.Step1.Title,
          disableBeacon: true,
          link: PageTour.Step1.DetailsLink,
        },
        {
          content: PageTour.Step2.Text,
          placement: 'auto',
          target: '#warehousePageSettings',
          title: PageTour.Step2.Title,
          disableBeacon: true,
          link: PageTour.Step2.DetailsLink,
        },
        {
          content: PageTour.Step3.Text,
          placement: 'auto',
          target: '#units',
          title: PageTour.Step3.Title,
          disableBeacon: true,
          link: PageTour.Step3.DetailsLink,
        },
        {
          content: PageTour.Step4.Text,
          placement: 'auto',
          target: '#warehouse1',
          title: PageTour.Step4.Title,
          disableBeacon: true,
          link: PageTour.Step4.DetailsLink,
        },
        {
          content: PageTour.Step5.Text,
          placement: 'auto',
          target: '#locationInfo',
          title: PageTour.Step5.Title,
          disableBeacon: true,
          link: PageTour.Step5.DetailsLink,
        },
        {
          content: PageTour.Step6.Text,
          placement: 'auto',
          target: '#locationUnits',
          title: PageTour.Step6.Title,
          disableBeacon: true,
          link: PageTour.Step6.DetailsLink,
        },
        {
          content: PageTour.Step7.Text,
          placement: 'auto',
          target: '#addUnit',
          title: PageTour.Step7.Title,
          disableBeacon: true,
          link: PageTour.Step7.DetailsLink,
        },
        {
          content: PageTour.Step8.Text,
          placement: 'auto',
          target: '#addBottomUnit',
          title: PageTour.Step8.Title,
          disableBeacon: true,
          link: PageTour.Step8.DetailsLink,
        },
        {
          content: PageTour.Step9.Text,
          placement: 'auto',
          target: '#products',
          title: PageTour.Step9.Title,
          disableBeacon: true,
          link: PageTour.Step9.DetailsLink,
        },
        {
          content: PageTour.Step10.Text,
          placement: 'auto',
          target: '#history',
          title: PageTour.Step10.Title,
          disableBeacon: true,
          link: PageTour.Step10.DetailsLink,
        },
        {
          content: PageTour.Step11.Text,
          placement: 'auto',
          target: '#productsTable',
          title: PageTour.Step11.Title,
          disableBeacon: true,
          link: PageTour.Step11.DetailsLink,
        },
      ],
    }),
    [PageTour],
  );

  const createUnitTour = useMemo<TourType>(
    () => ({
      id: 'createUnitTour',
      title: CreateUnitTour.Title,
      before: () => {
        dispatch(warehousePageActions.setCreateModal({ isVisible: true }));
      },
      after: () => {
        dispatch(warehousePageActions.setCreateModal({ isVisible: false }));
      },
      steps: [
        {
          content: CreateUnitTour.Step1.Text,
          placement: 'auto',
          target: '#createUnitModal',
          title: CreateUnitTour.Step1.Title,
          disableBeacon: true,
          link: CreateUnitTour.Step1.DetailsLink,
        },
      ],
    }),
    [CreateUnitTour],
  );

  const updateUnitTour = useMemo<TourType>(
    () => ({
      id: 'updateUnitTour',
      title: UpdateUnitTour.Title,
      before: () => {
        dispatch(warehousePageActions.setUpdateModal({ isVisible: true }));
      },
      after: () => {
        dispatch(warehousePageActions.setUpdateModal({ isVisible: false }));
      },
      steps: [
        {
          content: UpdateUnitTour.Step1.Text,
          placement: 'auto',
          target: '#updateUnitModal',
          title: UpdateUnitTour.Step1.Title,
          disableBeacon: true,
          link: UpdateUnitTour.Step1.DetailsLink,
        },
      ],
    }),
    [UpdateUnitTour],
  );

  return [pageTour, createUnitTour, updateUnitTour];
}
